var _investmentPlanApiCal;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import status from "./status";
import * as ActionTypes from "../../actions";

//Updates the status apiCalls data for different api call.
var investmentPlanApiCalls = (_investmentPlanApiCal = {
  fetchInvestmentPlans: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.GET_INVESTMENTPLANS_REQUEST, ActionTypes.GET_INVESTMENTPLANS_SUCCESS, ActionTypes.GET_INVESTMENTPLANS_FAILURE, ActionTypes.RESET_GET_INVESTMENTPLANS]
  })
}, _defineProperty(_investmentPlanApiCal, "fetchInvestmentPlans", status({
  mapActionToKey: function mapActionToKey() {
    return "undefined";
  },
  types: [ActionTypes.GET_INVESTMENTPLANS_REQUEST, ActionTypes.GET_INVESTMENTPLANS_SUCCESS, ActionTypes.GET_INVESTMENTPLANS_FAILURE, ActionTypes.RESET_GET_INVESTMENTPLANS]
})), _defineProperty(_investmentPlanApiCal, "postInvestmentPlan", status({
  mapActionToKey: function mapActionToKey() {
    return "undefined";
  },
  types: [ActionTypes.POST_INVESTMENTPLAN_REQUEST, ActionTypes.POST_INVESTMENTPLAN_SUCCESS, ActionTypes.POST_INVESTMENTPLAN_FAILURE, ActionTypes.RESET_POST_INVESTMENTPLAN]
})), _investmentPlanApiCal);
export default investmentPlanApiCalls;